const header = document.getElementById('site-header');
const announcementBar = document.querySelector('.announcement-bar');

// Function to get scroll trigger point
function getStickyTrigger() {
  return announcementBar ? announcementBar.offsetHeight : 0;
}

// Function to check and apply sticky class
function updateStickyHeader() {
  // When a dialog scroll-locks the body (position: fixed; top: -Npx),
  // window.scrollY returns 0. Don't remove is-stuck in that state.
  if (document.body.style.position === 'fixed') return;

  const triggerPoint = getStickyTrigger();

  if (window.scrollY > triggerPoint) {
    header.classList.add('is-stuck');
  } else {
    header.classList.remove('is-stuck');
  }
}

// Run on scroll
window.addEventListener('scroll', updateStickyHeader);

// Run on resize (recalculate trigger)
window.addEventListener('resize', updateStickyHeader);

// Run on first load
window.addEventListener('load', updateStickyHeader);



// Meganav / Mobile + Desktop Nav
function initMeganav(section = document) {
  const meganav =
    section === document
      ? document.getElementById('meganav')
      : section.querySelector('#meganav');

  if (!meganav || meganav.dataset.initialized) return;
  meganav.dataset.initialized = 'true';

  const useWithPlacement = meganav.dataset.useWithPlacement === 'true';
  if (useWithPlacement) {
    meganav.classList.remove('hidden');
    const placement = document.getElementById('meganav-wrapper');
    if (placement && meganav.parentElement !== placement) {
      // Remove any previously-placed meganav so Shopify editor reloads
      // don't leave a stale duplicate behind
      placement.querySelector('.meganav')?.remove();
      placement.append(meganav);
    }
  }

  const mq = window.matchMedia('(min-width: 768px)');
  const hamburger = section.querySelector('.header-hamburger');
  const closeButton = meganav.querySelector('.modal-button--close');

  // ── Mobile focus trap ──
  let _trapKeydown = null;
  let _trapFocusin = null;

  const trapFocusInDrawer = () => {
    removeFocusTrap();
    const focusable = Array.from(meganav.querySelectorAll(
      'a[href], button:enabled, [tabindex]:not([tabindex^="-"])'
    )).filter(el => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    _trapKeydown = e => {
      if (e.key !== 'Tab') return;
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && (document.activeElement === first || document.activeElement === meganav)) {
        e.preventDefault();
        last.focus();
      }
    };
    _trapFocusin = e => {
      if (e.target instanceof Node && !meganav.contains(e.target)) {
        e.stopPropagation();
        first.focus();
      }
    };
    document.addEventListener('keydown', _trapKeydown, true);
    document.addEventListener('focusin', _trapFocusin, true);
  };

  const removeFocusTrap = () => {
    if (_trapKeydown) { document.removeEventListener('keydown', _trapKeydown, true); _trapKeydown = null; }
    if (_trapFocusin) { document.removeEventListener('focusin', _trapFocusin, true); _trapFocusin = null; }
  };

  // ── Shared helpers ──

  const open = (trigger, panel, delay = 0) => {
    clearTimeout(trigger._closeTimer);
    trigger._openTimer = setTimeout(() => {
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    }, delay);
  };

  const close = (trigger, panel, delay = 0) => {
    clearTimeout(trigger._openTimer);
    trigger._closeTimer = setTimeout(() => {
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
    }, delay);
  };

  const toggle = (trigger, panel) => {
    trigger.getAttribute('aria-expanded') === 'true'
      ? close(trigger, panel)
      : open(trigger, panel);
  };

  // ── Mode switching ──

  const updateMode = () => {
    meganav.classList.toggle('desktop-nav', mq.matches);
    meganav.classList.toggle('mobile-nav', !mq.matches);

    meganav.querySelectorAll('[data-meganav-trigger][aria-expanded="true"]').forEach(trigger => {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', 'false');
      panel?.setAttribute('aria-hidden', 'true');
    });

    if (mq.matches) {
      document.body.classList.remove('drawer-open');
      meganav.classList.remove('is-on');
      hamburger?.setAttribute('aria-expanded', 'false');
      removeFocusTrap();
    }
  };
  updateMode();
  mq.addEventListener('change', updateMode);

  // Check if a dropdown has any visible children on desktop
  const hasVisibleContent = panel => {
    const inner = panel.querySelector('.meganav__dropdown-inner');
    if (!inner) return false;
    return Array.from(inner.children).some(el => el.offsetParent !== null);
  };

  // Mark L1 items whose dropdown has no visible desktop content
  if (mq.matches) {
    meganav.querySelectorAll('[data-meganav-trigger]').forEach(trigger => {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (panel && !hasVisibleContent(panel)) {
        trigger.closest('.meganav__nav-item')?.classList.add('meganav__nav-item--no-desktop-dropdown');
      }
    });
  }

  // ── Desktop hover ──

  meganav.addEventListener('mouseover', e => {
    if (!mq.matches) return;
    const item = e.target.closest('.meganav__nav-item');
    if (!item || !meganav.contains(item)) return;
    const trigger = item.querySelector('[data-meganav-trigger]');
    const panel = document.getElementById(trigger?.getAttribute('aria-controls'));
    if (trigger && panel && hasVisibleContent(panel)) open(trigger, panel, 150);
  });

  meganav.addEventListener('mouseout', e => {
    if (!mq.matches) return;
    const item = e.target.closest('.meganav__nav-item');
    if (!item || item.contains(e.relatedTarget)) return;
    if (item.contains(document.activeElement)) return;
    const trigger = item.querySelector('[data-meganav-trigger]');
    const panel = document.getElementById(trigger?.getAttribute('aria-controls'));
    if (trigger && panel) close(trigger, panel, 250);
  });

  const openDrawer = () => {
    document.body.classList.add('drawer-open');
    meganav.classList.add('is-on');
    hamburger?.setAttribute('aria-expanded', 'true');
    // Focus the close button after the slide-in transition starts
    requestAnimationFrame(() => {
      closeButton?.focus();
      trapFocusInDrawer();
    });
  };

  const closeDrawer = () => {
    meganav.classList.remove('is-on');
    hamburger?.setAttribute('aria-expanded', 'false');
    removeFocusTrap();
    hamburger?.focus();
    // Delay removing drawer-open until slide-out finishes so main content
    // stays behind the nav during the transition
    meganav.addEventListener('transitionend', () => {
      document.body.classList.remove('drawer-open');
    }, { once: true });
  };

  // Mobile triggers (L1 meganav + L2 accordion — all CSS-animated)
  // Only preventDefault when a dropdown panel exists; links without children navigate normally.
  meganav.addEventListener('click', e => {
    if (mq.matches) return; // desktop links navigate normally

    const trigger = e.target.closest('[data-meganav-trigger], [data-accordion-trigger]');
    if (!trigger) return;

    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return; // no children — let the <a> navigate to its href

    e.preventDefault();
    toggle(trigger, panel);
  });

  hamburger?.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);

  // Escape key (mobile)
  meganav.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (mq.matches) return; // desktop Escape handled by keyboard nav below

    // If any trigger is expanded, close it first
    const trigger = e.target.closest('[aria-expanded="true"]');
    if (trigger && trigger !== hamburger) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (panel) {
        close(trigger, panel);
        trigger.focus();
        return;
      }
    }

    // Otherwise close the entire drawer
    if (document.body.classList.contains('drawer-open')) {
      closeDrawer();
    }
  });

  // Accordion (section-level, for accordions outside the meganav)
  section.addEventListener('click', e => {
    if (mq.matches) return;

    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger || meganav.contains(trigger)) return; // skip meganav accordions (handled above)
    e.preventDefault();
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    toggle(trigger, panel);
  });

  section.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger || meganav.contains(trigger)) return; // skip meganav accordions (handled above)
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    close(trigger, panel);
    trigger.blur();
  });

  // ── Desktop keyboard navigation (W3C Disclosure Navigation pattern) ──

  const l1Triggers = Array.from(meganav.querySelectorAll('[data-meganav-trigger]'));

  const closeAllDropdowns = (except = null) => {
    l1Triggers.forEach(t => {
      if (t === except || t.getAttribute('aria-expanded') !== 'true') return;
      const p = document.getElementById(t.getAttribute('aria-controls'));
      if (!p) return;
      close(t, p, 0);
      p.querySelectorAll('nav.level-3').forEach(l3 => l3.setAttribute('aria-hidden', 'true'));
    });
  };

  const openDropdown = (trigger) => {
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    if (!hasVisibleContent(panel)) return;
    closeAllDropdowns(trigger);
    open(trigger, panel, 0);
    // L3 panels are aria-hidden="true" from Liquid (mobile accordion).
    // On desktop they're visually visible but aria-hidden removes them
    // from the accessibility tree. Fix that when the dropdown opens.
    panel.querySelectorAll('nav.level-3').forEach(l3 => l3.setAttribute('aria-hidden', 'false'));
  };

  const getFocusable = (panel) =>
    Array.from(panel.querySelectorAll('a[href], button:not([disabled])')).filter(el => el.offsetParent !== null);

  meganav.addEventListener('keydown', e => {
    if (!mq.matches) return;

    const trigger = e.target.closest('[data-meganav-trigger]');
    const dropdown = e.target.closest('.meganav__dropdown');

    // ── Focus is on an L1 trigger ──
    if (trigger && l1Triggers.includes(trigger)) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      const idx = l1Triggers.indexOf(trigger);

      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (isOpen) {
            close(trigger, panel, 0);
            panel.querySelectorAll('nav.level-3').forEach(l3 => l3.setAttribute('aria-hidden', 'true'));
          } else {
            openDropdown(trigger);
            const items = getFocusable(panel);
            if (items.length) items[0].focus();
          }
          break;

        case 'ArrowDown':
          if (isOpen) {
            e.preventDefault();
            const items = getFocusable(panel);
            if (items.length) items[0].focus();
          }
          break;

        case 'ArrowRight':
          e.preventDefault();
          closeAllDropdowns();
          if (isOpen) openDropdown(l1Triggers[(idx + 1) % l1Triggers.length]);
          l1Triggers[(idx + 1) % l1Triggers.length].focus();
          break;

        case 'ArrowLeft':
          e.preventDefault();
          closeAllDropdowns();
          if (isOpen) openDropdown(l1Triggers[(idx - 1 + l1Triggers.length) % l1Triggers.length]);
          l1Triggers[(idx - 1 + l1Triggers.length) % l1Triggers.length].focus();
          break;

        case 'Escape':
          if (isOpen) {
            e.preventDefault();
            e.stopImmediatePropagation();
            close(trigger, panel, 0);
            panel.querySelectorAll('nav.level-3').forEach(l3 => l3.setAttribute('aria-hidden', 'true'));
            trigger.focus();
          }
          break;
      }
      return;
    }

    // ── Focus is inside a dropdown ──
    if (dropdown) {
      const navItem = dropdown.closest('.meganav__nav-item');
      const trig = navItem?.querySelector('[data-meganav-trigger]');
      if (!trig) return;

      const items = getFocusable(dropdown);
      const cur = items.indexOf(e.target);
      const trigIdx = l1Triggers.indexOf(trig);

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (cur < items.length - 1) items[cur + 1].focus();
          break;

        case 'ArrowUp':
          e.preventDefault();
          if (cur > 0) items[cur - 1].focus();
          else trig.focus();
          break;

        case 'ArrowRight':
          e.preventDefault();
          closeAllDropdowns();
          openDropdown(l1Triggers[(trigIdx + 1) % l1Triggers.length]);
          l1Triggers[(trigIdx + 1) % l1Triggers.length].focus();
          break;

        case 'ArrowLeft':
          e.preventDefault();
          closeAllDropdowns();
          openDropdown(l1Triggers[(trigIdx - 1 + l1Triggers.length) % l1Triggers.length]);
          l1Triggers[(trigIdx - 1 + l1Triggers.length) % l1Triggers.length].focus();
          break;

        case 'Home':
          e.preventDefault();
          if (items.length) items[0].focus();
          break;

        case 'End':
          e.preventDefault();
          if (items.length) items[items.length - 1].focus();
          break;

        case 'Escape':
          e.preventDefault();
          e.stopImmediatePropagation();
          close(trig, dropdown, 0);
          dropdown.querySelectorAll('nav.level-3').forEach(l3 => l3.setAttribute('aria-hidden', 'true'));
          trig.focus();
          break;
      }
    }
  });

  meganav.addEventListener('focusout', () => {
    if (!mq.matches) return;
    requestAnimationFrame(() => {
      const focused = document.activeElement;
      if (!meganav.contains(focused)) {
        closeAllDropdowns();
        return;
      }
      l1Triggers.forEach(t => {
        if (t.getAttribute('aria-expanded') !== 'true') return;
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (!p) return;
        if (focused !== t && !p.contains(focused)) {
          close(t, p, 0);
          p.querySelectorAll('nav.level-3').forEach(l3 => l3.setAttribute('aria-hidden', 'true'));
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initMeganav());
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => requestAnimationFrame(() => initMeganav(e.target)));
}
